import { useEffect, useState } from "react";
import { useI18n } from "../contexts/I18nContext";
import { Clock } from "lucide-react";

export default function CountdownTimer({ endAt }) {
  const { t } = useI18n();
  const [tick, setTick] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setTick(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!endAt) return null;
  const end = new Date(endAt).getTime();
  const diff = Math.max(0, end - tick);
  if (diff <= 0) return <span className="text-[#C85A32] font-bold inline-flex items-center gap-1"><Clock className="w-4 h-4"/>{t("auction_ended")}</span>;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return (
    <span className="inline-flex items-center gap-2 font-mono font-bold text-[#1A1A18]" data-testid="countdown-timer">
      <Clock className="w-4 h-4 text-[#C85A32] pulse-dot"/>
      {d > 0 && <span>{d}{t("days")}</span>}
      <span>{String(h).padStart(2,"0")}{t("hours")}</span>
      <span>{String(m).padStart(2,"0")}{t("minutes")}</span>
      <span>{String(s).padStart(2,"0")}{t("seconds")}</span>
    </span>
  );
}
